import { Component, OnInit } from '@angular/core';
import { ApiService } from "../services/api.service";
import { map, tap } from "rxjs/operators";

@Component({
  selector: 'app-pet-prescriptions',
  templateUrl: './pet-prescriptions.component.html',
  styleUrls: ['./pet-prescriptions.component.scss']
})
export class PetPrescriptionsComponent implements OnInit {
  public newDisCardModal : boolean = false;
  constructor(
    public ApiService: ApiService,
  ) { }

  ngOnInit() {
    $(".petNavPh").click(function() {
      $('html,body').animate({
          scrollTop: $("#navSearchBar").offset().top},
          'slow');
  });
  this.googlegeneric('023518', 'ARX', '100-4542');
  this.applegeneric('023518', 'ARX', '100-4542');
  let userAgent = window.navigator.userAgent;
  let devicetype = this.GetUserAgent(userAgent);
  let browsername = this.GetBrowserName(userAgent);
  //  alert(devicetype + '--' + browsername);
  //  --Chrome
  if(devicetype == "Desktop") {
  this.android=true;
  this.ios=true;
  }
  if(devicetype =="iPhone") {
  this.android=false;
  this.ios=true;
  }
  if(devicetype =="Android") {
  this.android=true;
  this.ios=false;
  }

  }
  slides = [
    {
      img: "../assets/images/thumbnail_icon1.png",
      heading: "Honest Discounts iOS App user",
      source: "Florida, USA",
      text:
        "I have been using PatientRx Discount from 2017. Till now I feel very comfortable and cancelled my SBI account after using paytm. Hope you start using Honest Discount. love you"
    },
    {
      img: "../assets/images/thumbnail_icon2.png",
      heading: "Honest Discounts iOS App user",
      source: "Florida, USA",

      text:
        "I have been using PatientRx Discount from 2017. Till now I feel very comfortable and cancelled my SBI account after using paytm. Hope you start using Honest Discount. love you"
    },
    {
      img: "../assets/images/thumbnail_icon3.png",
      heading: "Honest Discounts iOS App user",
      source: "Florida, USA",
      text: "I have been using PatientRx Discount from 2017. Till now I feel very comfortable and cancelled my SBI account after using paytm. Hope you start using Honest Discount. love you"
    },
    {
      img: "../assets/images/thumbnail_icon1.png",
      heading: "Honest Discounts iOS App user",
      source: "Florida, USA",
      text:
        "I have been using PatientRx Discount from 2017. Till now I feel very comfortable and cancelled my SBI account after using paytm. Hope you start using Honest Discount. love you"
    }
  ];
  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: "<div class='arrow-forward'></div>",
    prevArrow: "<div class='arrow-backward'></div>",
    dots: false,
    infinite: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };
 showemailpopup:any=false;
 googlegenericpassval:any="";
 applegenericpassval:any="";
 android:any=true;
 ios:any=true;
 desktop:any=true;
 newCardGroupNo: any = "";
 CloseNewCardModal(){
    this.newDisCardModal = false;
  }
  GetUserAgent(UserAgent_Raw) {
    if (/Mobi|Android/i.test(UserAgent_Raw)) {
        if (/iPhone|iPad|iPod/i.test(UserAgent_Raw)) {
            return 'iPhone';
        }
        else {
            return 'Android';
        }
    } else {
        return 'Desktop';
    }
}
googlegeneric(bin, pcn, memberid){
  this.ApiService.googlegeneric(bin, pcn, window.localStorage.getItem("UserGroup"), memberid)
  .pipe(map(res => res.json()))
  .subscribe(
    data => {
if(data[0].passlink != "") {
this.googlegenericpassval = data[0].passlink
}
    })
}
applegeneric(bin, pcn, memberid){
  this.ApiService.applegeneric(bin, pcn, window.localStorage.getItem("UserGroup"), memberid)
  .pipe(map(res => res.json()))
  .subscribe(
    data => {
if(data[0].passlink != "") {
this.applegenericpassval = data[0].passlink
}
    })
}
newDiscountModal() {
  this.newDisCardModal = true;
  this.newCardGroupNo = window.localStorage.getItem("UserGroup")

}
GetBrowserName(UserAgent_Raw) {
    if (/Firefox/i.test(UserAgent_Raw)) {
        return 'Firefox';
    } else if (/Chrome/i.test(UserAgent_Raw)) {
        return 'Chrome';
    } else if (/Safari/i.test(UserAgent_Raw)) {
        return 'Safari';
    } else if (/MSIE|Trident/i.test(UserAgent_Raw)) {
        return 'Internet Explorer';
    } else if (/Edge/i.test(UserAgent_Raw)) {
        return 'Edge';
    } else if (/Opera|OPR/i.test(UserAgent_Raw)) {
        return 'Opera';
    } else if (/Brave/i.test(UserAgent_Raw)) {
        return 'Brave';
    } else if (/Vivaldi/i.test(UserAgent_Raw)) {
        return 'Vivaldi';
    } else if (/Yandex/i.test(UserAgent_Raw)) {
        return 'Yandex';
    } else if (/Chromium/i.test(UserAgent_Raw)) {
        return 'Chromium';
    } else {
        return 'Unknown';
    }
}
  openpass(url) {
    let userAgent = window.navigator.userAgent;
    let devicetype = this.GetUserAgent(userAgent);
    let browsername = this.GetBrowserName(userAgent);

    if(devicetype == "Desktop") {
      window.open(url)
     }
     
     if(devicetype =="Android") {
      window.open(url)
     }
     if(devicetype =="iPhone" && browsername == "Safari") {
      // window.open(url)      
      this.showemailpopup=true;
     }
     if(devicetype =="iPhone" && browsername != "Safari")  {
      this.showemailpopup=true;
     }
    
  }
  PrintMe() {
    setTimeout(() => {
      window.print();

    }, 600);
  }
}